import { canWriteToClipboard as m } from "../canWriteToClipboard/index.js";
import { convertImageToPNG as l } from "../convertImageToPNG/index.js";
import { getImageBlob as f } from "../getImageBlob/index.js";
async function g(t, i) {
  if (typeof t == "string")
    return ["text/plain", new Blob([t], { type: "text/plain" })];
  const { mimeType: e, data: r } = t;
  if ((e === "text/plain" || e === "text/html") && typeof r == "string")
    return [e, new Blob([r], { type: e })];
  if (e === "image/jpeg" || e === "image/png") {
    if (r instanceof Blob)
      return ["image/png", await l(r)];
    const a = r.href;
    let o = i.get(a);
    o || (o = f({ mimeType: e, url: r }), i.set(a, o), o.catch(() => i.delete(a)));
    const p = await o;
    return ["image/png", await l(p)];
  }
  throw new DOMException("Unsupported clipboard item type", "DataError");
}
async function d(t, i = {}) {
  if (!await m())
    throw new DOMException(
      "Copy to clipboard is not supported in this browser.",
      "NotSupportedError"
    );
  if (typeof t == "string")
    return await navigator.clipboard.writeText(t), !0;
  const r = i.cache ?? /* @__PURE__ */ new Map(), o = (Array.isArray(t) ? t : [t]).map((n) => g(n, r)), s = (await Promise.allSettled(o)).filter((n) => n.status === "fulfilled").map((n) => n.value);
  if (s.length === 0)
    return !1;
  const c = Object.fromEntries(s);
  return await navigator.clipboard.write([new ClipboardItem(c)]), !0;
}
export {
  d as copyToClipboard
};
